<template>
    <div id="expressPrintArea">
        <div v-for="(item, index) in printData" :key="index" :style="{ marginTop: index != 0 ? '-10px' : '0' }">
            <div :style="{ height: index != 0 ? '130mm' : '120mm' }">
                <div style="height: 10mm;" v-if="index != 0"></div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black"></div>
                <div style="height:40px;width:100%;display: flex;">
                    <div style="width:16mm;border-right:1px solid black"></div>
                    <div style="width:30mm;;border-right:1px solid black">
                        <div style="background-color: black;color:white">代收：￥{{ Number(item.codValue).toFixed(2) }}</div>
                        <div
                            style="font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 16px;line-height: 20px;text-align: center;">
                            月结</div>
                    </div>
                    <div style="width:30mm;overflow: hidden;display: flex;align-items: center;flex-wrap: wrap;">
                        {{ item.transType }}
                    </div>
                    <!-- {{ item.departCityName }} -->
                </div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="height: 30px;text-align: center;font-weight: bold;line-height: 30px;">
                    {{ item.transNo }}
                </div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="margin-top: 10px;height: 60px;display: flex;">
                    <div
                        style="float:left;margin-left: 10mm;font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 16px;line-height: 20px;margin-top: 10px;">
                        [送]
                    </div>
                    <div style="float:right;margin-right:35mm">
                        <div
                            style="font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 16px;line-height: 20px;">
                            {{ item.receiveOrgName }}
                        </div>
                        <!-- <div
                            style="font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 16px;line-height: 20px;">
                            {{ item.lastOutLoadOrgName }}
                        </div> -->
                    </div>
                </div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="width: 76mm;height: 30px;display: flex;justify-content: space-between;">
                    <div
                        style="width:50mm;text-align: center; float:left;font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 16px;line-height: 30px;">
                        纸
                    </div>
                    <div style="width:1px;height:30px;background-color: black;"></div>
                    <div
                        style="float:right;font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 16px;line-height: 20px;margin-right: 40px;line-height: 30px;">
                        <!-- {{ index + 1 }}/{{ printData.length }} -->
                        {{ item.order }}
                    </div>
                </div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="font-weight: bold;margin-left: 10px;" v-if="item.isM == '是' && item.order.substr(0, 1) != '1'">
                    母<span style="margin-left: 10px;">{{ item.m }}</span>
                </div>
                <div style="font-weight: bold;margin-left: 10px;height: 20px;" v-else>
                    <span style="margin-left: 10px;"></span>
                </div>
                <div
                    style="display:flex;justify-content: space-between; font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 12px;line-height: 16px; border-bottom:1px solid black;margin-top: 50px;">
                    <div v-if="item.isM == '是' && item.order.substr(0, 1) != '1'"
                        style="margin-top: -4px;margin-left: 10px;">子
                    </div>
                    <div v-else-if="item.isM == '是' && item.order.substr(0, 1) == '1'"
                        style="margin-top: -4px;margin-left: 10px;">母</div>
                    <div v-else></div>
                    <div style="margin-top: -4px;margin-right: 8px;">已验视</div>
                </div>
                <!-- <div
                    style="font-family: 'Arial Negreta', 'Arial Normal', 'Arial';font-weight: 700;font-style: normal;font-size: 12px;text-align: right;line-height: 16px; border-bottom:1px solid black;margin-top: 60px;margin-right:10px">
                    
                </div> -->
                <div style="height:60px;display: flex;justify-content: start;">
                    <div><img src="https://vip.deppon.com/vas-cas-web/img/recipient.png"
                            style="width: 35px;height: 40px;margin-top: 10px;margin-left: 20px;" /></div>
                    <div style="margin-right: 20px;margin-top: 10px;">
                        <div style="font-size: 10px;line-height: 12px;">{{ item.conName || 'cdd' }}</div>
                        <div style="font-size: 10px;line-height: 12px;">{{ item.conPhone || '15011111111' }}</div>
                        <div style="font-size: 10px;line-height: 12px;">{{ item.caddress || '上海市浦东新区' }}</div>
                    </div>
                </div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="height: 70px;">
                    <div>签收单：无需返单</div>
                    <div style="margin-right: 20px;display: flex;flex-wrap: wrap;">
                        <div style="width:30%; font-size: 10px;line-height: 12px;">寄 {{ item.shipperName }}</div>
                        <div style="width:30%;font-size: 10px;line-height: 12px;margin-right: 20px;">{{ item.shipperPhone }}
                        </div>
                        <div style="width:40%;font-size: 10px;line-height: 12px;margin-right: 20px;">{{ item.saddress }}
                        </div>

                    </div>
                    <div style="font-size: 12px;line-height: 14px;margin-top: 10px;">
                        <div>品名：{{ item.cargoName }}</div>
                        <div style="margin-top: 10px;">备注：{{ item.transNote }}</div>
                    </div>
                </div>
                <!-- <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="font-size: 10px;line-height: 13px;height:30px;">
                    <div>签收单：无需返单</div>
                    <div>返单要求：原单原路返回</div>
                </div>
                <div style="height: 1px;width: 76mm;border-bottom:1px solid black;"></div>
                <div style="font-size: 12px;line-height: 14px;">
                    <div>品名{{ item.cargoName }}</div>
                    <div>备注：{{ item.transNote }}</div>
                </div> -->
                <div style="margin-top: 50px;">
                    <div style="float:left;font-size: 10px;line-height: 12px">打印时间： <span style="margin-right:10px">{{
                        printTime }}</span></div>
                    <div style="float: right;font-size: 10px;line-height: 12px;margin-right: 10px;">第{{ index + 1 }}单</div>
                </div>
                <!-- <div style="page-break-after: always;"></div> -->
            </div>

        </div>


    </div>
</template>
<script>
export default {
    name: 'expressPrintArea',
    props: {
        printData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            // printData: []
            printTime: ''
        }
    },
    computed: {
    },
    created() {
        this.printTime = this.getTime()
        console.log(this.printData)
    },
    methods: {
        getTime() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hour = date.getHours();
            const minite = date.getMinutes();
            const seconds = date.getSeconds();
            return `${year}${month}${day} ${hour < 10 ? '0' + hour : hour}:${minite < 10 ? '0' + minite : minite}:${seconds < 10 ? '0' + seconds : seconds}`
        },
    }
}
</script>
<style scoped>
#expressPrintArea {
    width: 76mm;
    height: 130mm;
    /* margin-left: 100px; */
    /*  float: left; */
    /* background: url('../images/order/lttBackground.jpg') no-repeat; */
    /* background-size: 104mm 175mm;
    padding: 4mm 0.5mm 0.5mm 2.3mm; */
}
</style>
